import { render, staticRenderFns } from "./RegisterCovid.vue?vue&type=template&id=0191980f&"
import script from "./RegisterCovid.vue?vue&type=script&lang=js&"
export * from "./RegisterCovid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports